<section style="background-color: #f9f9f9; padding-top: 50px; padding-bottom: 50px;">
  <div class="container" style="padding: 0 15px;">
    <div class="row">
      <div class="col-md-12">
        <!-- Content Category Name at the top of the page -->
        <h2 style="font-size: 2rem; font-weight: bold; text-align: center; color: #333; margin-bottom: 30px;">
          {{ News_event_data[0]?.ContentCategoryName }}
        </h2>

        <div class="dashboard">
          <ng-container *ngFor="let item of News_event_data">
            <div class="publication" style="margin-bottom: 30px; transition: all 0.3s ease-in-out;">
              <a [href]="item.ContentUrl" target="_blank" download>
                <div
                  class="card shadow-sm"
                  style="border-radius: 12px; overflow: hidden; background-color: #fff; position: relative; height: 350px;">
                  <img [src]="item.ShowAttachments[0].FilePath" alt="Publication" class="card-img-top" style="height: 200px; object-fit: cover; transition: transform 0.3s ease;">
                  <div class="card-body" style="padding: 15px;">
                    <h3 style="font-size: 1.2rem; font-weight: bold; color: #333; text-align: center;">
                      {{ item.TitleEn }}
                    </h3>
                    <p style="font-size: 0.9rem; color: #777; text-align: center; margin-top: 10px; padding: 0 15px;">
                      <!-- <span>Description of Publication 1</span> -->
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</section>
